import round from 'lodash/round';
import { calculateExtraWeightPrice } from '../../helpers/network';
import { DOMESTIC_SERVICES } from './constants';

const WEIGHTS = [5, 10, 20, 25, 30];

// eslint-disable-next-line max-lines-per-function
export const calculateDomesticPrices = prices => {
  const shipToShopBasePrice = prices[DOMESTIC_SERVICES.SHIP_TO_SHOP].baseRate;
  const shipToShopBasePriceWithVatRate =
    prices[DOMESTIC_SERVICES.SHIP_TO_SHOP].baseRateWithVatRate;

  const doorToShopBase = round(
    shipToShopBasePrice +
      prices[DOMESTIC_SERVICES.SHIP_TO_SHOP].driverCollectionSurcharge,
    2
  );
  const doorToShopBaseWithVatRate = round(
    shipToShopBasePriceWithVatRate +
      prices[DOMESTIC_SERVICES.SHIP_TO_SHOP].driverCollectionSurcharge,
    2
  );

  const nextDayDeliveryBasePrice =
    prices[DOMESTIC_SERVICES.PARCEL_NEXT_DAY].baseRate;
  const nextDayDeliveryBasePriceWithVatRate =
    prices[DOMESTIC_SERVICES.PARCEL_NEXT_DAY].baseRateWithVatRate;

  const doorToDoorBasePrice = round(
    nextDayDeliveryBasePrice +
      prices[DOMESTIC_SERVICES.PARCEL_NEXT_DAY].driverCollectionSurcharge,
    2
  );
  const doorToDoorBasePriceWithVatRate = round(
    nextDayDeliveryBasePriceWithVatRate +
      prices[DOMESTIC_SERVICES.PARCEL_NEXT_DAY].driverCollectionSurcharge,
    2
  );
  const shopToShop = {
    base: shipToShopBasePrice,
    baseWithVatRate: shipToShopBasePriceWithVatRate,
  };
  const doorToShop = {
    base: doorToShopBase,
    baseWithVatRate: doorToShopBaseWithVatRate,
  };
  const nextDayDelivery = {
    fromShop: nextDayDeliveryBasePrice,
    fromShopWithVatRate: nextDayDeliveryBasePriceWithVatRate,
    doorToDoor: {
      base: doorToDoorBasePrice,
      baseWithVatRate: doorToDoorBasePriceWithVatRate,
    },
    doorToDoorBy12: round(
      prices[DOMESTIC_SERVICES.PARCEL_BY_12].baseRate +
        prices[DOMESTIC_SERVICES.PARCEL_BY_12].driverCollectionSurcharge,
      2
    ),
    doorToDoorBy12WithVatRate: round(
      prices[DOMESTIC_SERVICES.PARCEL_BY_12].baseRateWithVatRate +
        prices[DOMESTIC_SERVICES.PARCEL_BY_12].driverCollectionSurcharge,
      2
    ),
    doorToDoorBy10: round(
      prices[DOMESTIC_SERVICES.PARCEL_BY_10_30].baseRate +
        prices[DOMESTIC_SERVICES.PARCEL_BY_10_30].driverCollectionSurcharge,
      2
    ),
    doorToDoorBy10WithVatRate: round(
      prices[DOMESTIC_SERVICES.PARCEL_BY_10_30].baseRateWithVatRate +
        prices[DOMESTIC_SERVICES.PARCEL_BY_10_30].driverCollectionSurcharge,
      2
    ),
  };
  const saturdayDelivery = {
    base: round(prices[DOMESTIC_SERVICES.PARCEL_SATURDAY].baseRate, 2),
    baseWithVatRate: round(
      prices[DOMESTIC_SERVICES.PARCEL_SATURDAY].baseRateWithVatRate,
      2
    ),
    doorToDoor: round(
      prices[DOMESTIC_SERVICES.PARCEL_SATURDAY].baseRate +
        prices[DOMESTIC_SERVICES.PARCEL_SATURDAY].driverCollectionSurcharge,
      2
    ),
    doorToDoorWithVatRate: round(
      prices[DOMESTIC_SERVICES.PARCEL_SATURDAY].baseRateWithVatRate +
        prices[DOMESTIC_SERVICES.PARCEL_SATURDAY].driverCollectionSurcharge,
      2
    ),
    doorToDoorBy12: round(
      prices[DOMESTIC_SERVICES.PARCEL_SAT_BY_12].baseRate +
        prices[DOMESTIC_SERVICES.PARCEL_SAT_BY_12].driverCollectionSurcharge,
      2
    ),
    doorToDoorBy12WithVatRate: round(
      prices[DOMESTIC_SERVICES.PARCEL_SAT_BY_12].baseRateWithVatRate +
        prices[DOMESTIC_SERVICES.PARCEL_SAT_BY_12].driverCollectionSurcharge,
      2
    ),
  };
  const sundayDelivery = {
    doorToDoor: round(
      prices[DOMESTIC_SERVICES.PARCEL_SUNDAY].baseRate +
        prices[DOMESTIC_SERVICES.PARCEL_SUNDAY].driverCollectionSurcharge,
      2
    ),
    doorToDoorWithVatRate: round(
      prices[DOMESTIC_SERVICES.PARCEL_SUNDAY].baseRateWithVatRate +
        prices[DOMESTIC_SERVICES.PARCEL_SUNDAY].driverCollectionSurcharge,
      2
    ),
  };

  WEIGHTS.forEach(weight => {
    const key = `${weight}kg`;
    const extraWeightShip2Shop = calculateExtraWeightPrice({
      ...prices[DOMESTIC_SERVICES.SHIP_TO_SHOP],
      weight,
    });
    const extraWeightDoorToDoor = calculateExtraWeightPrice({
      ...prices[DOMESTIC_SERVICES.PARCEL_NEXT_DAY],
      weight,
    });

    doorToShop[key] = round(doorToShopBase + extraWeightShip2Shop, 2);
    doorToShop[`${key}WithVatRate`] = round(
      doorToShopBaseWithVatRate + extraWeightShip2Shop,
      2
    );

    shopToShop[key] = round(shipToShopBasePrice + extraWeightShip2Shop, 2);
    shopToShop[`${key}WithVatRate`] = round(
      shipToShopBasePriceWithVatRate + extraWeightShip2Shop,
      2
    );

    nextDayDelivery[key] = round(
      nextDayDeliveryBasePrice + extraWeightDoorToDoor,
      2
    );
    nextDayDelivery[`${key}WithVatRate`] = round(
      nextDayDeliveryBasePriceWithVatRate + extraWeightDoorToDoor,
      2
    );
    nextDayDelivery.doorToDoor[key] = round(
      doorToDoorBasePrice + extraWeightDoorToDoor,
      2
    );
    nextDayDelivery.doorToDoor[`${key}WithVatRate`] = round(
      doorToDoorBasePriceWithVatRate + extraWeightDoorToDoor,
      2
    );
  });

  return {
    shopToShop,
    doorToShop,
    nextDayDelivery,
    saturdayDelivery,
    sundayDelivery,
  };
};
